import { type RefObject, useEffect, useState } from 'react';

type UseHeaderOffsetProps = {
    ref: RefObject<HTMLDivElement>;
};

const useHeaderOffset = ({ ref }: UseHeaderOffsetProps) => {
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const handleSetValue = () => {
            setOffset((ref?.current?.offsetWidth ?? 0) - (ref?.current?.clientWidth ?? 0));
        };

        const listObserver = new ResizeObserver(handleSetValue);

        if (ref?.current) {
            listObserver.observe(ref?.current);
        }

        return () => {
            if (ref?.current) {
                listObserver.unobserve(ref?.current);
            }
        };
    }, [ref?.current]);

    return offset;
};

export default useHeaderOffset;
